import { MessageNodeActionTypes } from '../types'
import BaseSendMessageAction from './BaseAction'

export default class TypingAction extends BaseSendMessageAction {
  declare type: MessageNodeActionTypes.Typing
  time!: number
}
